//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'MultiCheckboxField',
  props: ['value', 'label', 'name', 'error', 'options'],
  methods: {
    updateValue: function (e) {
      let values = this.value ? this.value : [];
      const value = isNaN(e.value) ? e.value : parseInt(e.value);
      if(e.checked){
        if(!values.includes(value)){
          values.push(value);
        }
      } else {
        if(values.includes(value)){
          values.splice(values.indexOf(value), 1);
        }
      }
      this.$emit('input', values);
    },
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/fields/MultiCheckboxField.vue